import React from "react";

interface Kxd5DCostIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const Kxd5DCostIcon: React.FC<Kxd5DCostIconProps> = ({
  width = 20,
  height = 20,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M18.3333 0C18.7754 0 19.1992 0.175721 19.5117 0.488281C19.8243 0.800842 20 1.22464 20 1.66667V18.3333C20 18.7754 19.8243 19.1992 19.5117 19.5117C19.1992 19.8243 18.7754 20 18.3333 20H1.66667C1.22464 20 0.800842 19.8243 0.488281 19.5117C0.175721 19.1992 0 18.7754 0 18.3333V1.66667C0 1.22464 0.175721 0.800842 0.488281 0.488281C0.800842 0.175721 1.22464 0 1.66667 0H18.3333ZM9.9273 4.44444C8.72032 4.46024 7.55138 4.86936 6.59722 5.60872C5.64306 6.3481 4.95528 7.37791 4.63867 8.54275C4.32211 9.70778 4.39382 10.9452 4.84267 12.066C5.29154 13.1865 6.09364 14.1304 7.12674 14.7548C8.15992 15.3791 9.36884 15.6499 10.5697 15.5263C11.7704 15.4025 12.8984 14.8908 13.7826 14.069C14.6667 13.2472 15.2588 12.1596 15.4698 10.9711L14.0462 10.7183C13.8901 11.5975 13.4514 12.4021 12.7973 13.01C12.1433 13.6178 11.3092 13.996 10.421 14.0875C9.53274 14.1789 8.63859 13.9786 7.87435 13.5167C7.11021 13.0548 6.51686 12.3567 6.1849 11.5278C5.85296 10.6989 5.79998 9.78417 6.03407 8.92253C6.26822 8.06081 6.77679 7.29826 7.48264 6.7513C8.1885 6.20435 9.05394 5.90244 9.94683 5.89084C10.8396 5.87929 11.7119 6.15897 12.4316 6.68728L13.2878 5.52192C12.3146 4.80749 11.1345 4.42876 9.9273 4.44444ZM10 6.57227C8.10678 6.57227 6.57227 8.10678 6.57227 10C6.57227 11.8932 8.10678 13.4277 10 13.4277C11.8932 13.4277 13.4277 11.8932 13.4277 10C13.4277 8.10677 11.8932 6.57227 10 6.57227ZM12.7582 6.95421C13.2306 7.38205 13.5978 7.91424 13.8292 8.50803C14.0605 9.10164 14.15 9.74102 14.0918 10.3754L15.5328 10.5078C15.6115 9.65002 15.4896 8.78548 15.1769 7.98286C14.864 7.18007 14.3679 6.46059 13.7294 5.88216L12.7582 6.95421Z" fill="#002366"/>
    </svg>
  );
};

export default Kxd5DCostIcon;
